import { createAction, createReducer } from '@reduxjs/toolkit';
import { navigationRef } from '@helpers';
import { TimePeriod } from '@v2/pages/machines/common/enums';
import { CHART_TYPE } from '@v2/pages/common/constants/base.constants';
import type { RootState } from '@store/types';
import type { AppDispatch } from '@reducers/utils/types';
import type { ParamsState } from './types';

// Re-export types for consumers
export type { ParamsState } from './types';

// === Initial State ===

const initState: ParamsState = {
  timePeriod: TimePeriod.DAY,
  chartType: CHART_TYPE.LINE,
};

// === Selectors ===

export const selectTimePeriod = (state: RootState) => state.params.timePeriod;
export const selectChartType = (state: RootState) => state.params.chartType;

// === Actions ===

export const setTimePeriodAction = createAction<TimePeriod>('setTimePeriodAction');
export const setChartTypeAction = createAction<CHART_TYPE>('setChartTypeAction');

// === Thunks ===

export const setTimePeriod = (timePeriod: TimePeriod) => (dispatch: AppDispatch) => {
  navigationRef?.current?.setParams({ timePeriod: timePeriod || undefined });
  if (timePeriod) {
    dispatch(setTimePeriodAction(timePeriod));
  }
};

export const setChartType = (chartType: CHART_TYPE) => (dispatch: AppDispatch) => {
  navigationRef?.current?.setParams({ chart: chartType || undefined });
  if (chartType) {
    dispatch(setChartTypeAction(chartType));
  }
};

// === Reducer ===

export default createReducer<ParamsState>(initState, {
  [setTimePeriodAction.type]: (state, action) => {
    return { ...state, timePeriod: action.payload };
  },
  [setChartTypeAction.type]: (state, action) => {
    return { ...state, chartType: action.payload };
  },
});
